import React from 'react';
import { PolicyStatus } from '../../types';

/**
 * The vault's status pill.
 *
 * NO RED AND NO AMBER, anywhere, deliberately. The vault is opt-in per policy:
 * many services will keep some or all policies on paper indefinitely, and an
 * empty slot is an OFFER ("here is where this would live"), not a compliance
 * alarm. Colouring a NOT_ADDED slot red would turn a helpful register into a
 * scoreboard nobody wants to open.
 *
 * "Held on paper" is styled as a real, respectable state rather than a
 * degraded one — it is how most services operate today.
 */
const STYLES: Record<PolicyStatus, { label: string; className: string }> = {
  [PolicyStatus.NOT_ADDED]: {
    label: 'Not in vault yet',
    className: 'bg-gray-100 text-gray-600 ring-gray-500/20',
  },
  [PolicyStatus.PAPER_BASED]: {
    label: 'Held on paper',
    className: 'bg-blue-50 text-blue-700 ring-blue-700/20',
  },
  [PolicyStatus.ACTIVE]: {
    label: 'In vault',
    className: 'bg-green-50 text-green-700 ring-green-600/20',
  },
  [PolicyStatus.ARCHIVED]: {
    label: 'Archived',
    className: 'bg-gray-100 text-gray-500 ring-gray-500/20',
  },
};

export const PolicyStatusPill: React.FC<{ status: PolicyStatus }> = ({ status }) => {
  const { label, className } = STYLES[status];
  return (
    <span
      data-testid={`policy-status-${status}`}
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${className}`}
    >
      {label}
    </span>
  );
};
